<template>
  <div>
    <b-card :title="$t('finance.filters')">
      <!-- <b-form-group
        label-for="filterIncomeCashbox"
      >
        <h6>
          <strong> {{ $t('finance.cash_box') }} </strong>
        </h6>
        <v-select
          id="filterIncomeCashbox"
          v-model="query_params.income_cashbox"
          label="title"
          :options="optionIncomeCashbox"
          :reduce="group => group.id"
          @input="emitFiltered"
        />
      </b-form-group> -->
      <b-form-group label-for="filterIncomeCashbox">
        <h6>
          <strong> {{ $t('finance.payment_type') }} </strong>
        </h6>
        <v-select
          id="filterPaymentType"
          v-model="query_params.payment_type"
          :get-option-label="type => type.title[$i18n.locale]"
          :options="payment_type_options"
          :reduce="type => type.value"
          @input="emitFiltered"
        />
      </b-form-group>
      <b-form-group label-for="filterIncomeCashbox">
        <h6>
          <strong> {{ $t('finance.income_type') }} </strong>
        </h6>
        <v-select
          id="filterIncomeType"
          v-model="query_params.income_type"
          :get-option-label="type => type.title[$i18n.locale]"
          :options="income_type_options"
          :reduce="type => type.value"
          @input="emitFiltered"
        />
      </b-form-group>
      <b-form-group label-for="filterIncomeCashbox">
        <h6>
          <strong> {{ $t('clients.contract') }} </strong>
        </h6>
        <v-select
          id="filterContract"
          v-model="query_params.contract"
          label="contract_number"
          :options="GET_CONTRACTS.results"
          :reduce="type => type.id"
          @input="emitFiltered"
        />
      </b-form-group>
      <b-form-group label-for="birthdayStart">
        <h6>
          <strong> {{ $t('objects.with') }} </strong>

        </h6>

        <flat-pickr
          v-model="query_params.from_date"
          class="form-control bg-white"
          style="max-width: 250px;"
          :config="configdateTimePicker"
          @on-change="emitFiltered"
        />
      </b-form-group>
      <b-form-group label-for="birthdayStart">
        <h6>
          <strong> {{ $t('objects.by') }} </strong>
        </h6>

        <flat-pickr
          v-model="query_params.to_date"
          class="form-control bg-white"
          style="max-width: 250px;"
          :config="configdateTimePicker"
          @on-change="emitFiltered"
        />
      </b-form-group>
      <b-form-group label-for="birthdayStart">
        <h6>
          <strong> {{ $t('navbars.obj') }} </strong>
        </h6>

        <v-select
          id="filterContract"
          v-model="query_params.object"
          label="title"
          :options="GET_OBJECTS"
          :reduce="type => type.id"
          @input="emitFiltered"
        />
      </b-form-group>
      <b-button
        variant="outline-warning"
        @click="clearData"
      >
        {{ $t('generals.clear') }}
      </b-button>
    </b-card>
  </div>
</template>

<script>
import { BCard, BFormGroup, BButton } from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from 'flatpickr/dist/l10n/ru'

export default {
  components: {
    BCard,
    BFormGroup,
    vSelect,
    flatPickr,
    BButton,
  },
  data() {
    return {
      query_params: {
        income_cashbox: null,
        payment_type: null,
        income_type: null,
        from_date: null,
        to_date: null,
        contract: null,
        object: null,
      },
      optionIncomeCashbox: [],
      payment_type_options: [
        {
          title: {
            ru: 'Банк',
            uz: 'Bank',
          },
          value: 'cash',
        },
        {
          title: {
            ru: 'Счет',
            uz: 'Hisob',
          },
          value: 'noncash',
        },
        {
          title: {
            ru: 'Бартер',
            uz: 'Barter',
          },
          value: 'barter',
        },
      ],
      configdateTimePicker: {
        altInput: true,
        altFormat: 'd.m.Y',
        dateFormat: 'Y-m-d',
        locale: Russian,
      },
      income_type_options: [
        {
          title: {
            ru: 'Продажа',
            uz: 'Sotuv',
          },
          value: 'sale',
        },
        {
          title: {
            ru: 'Дебитор',
            uz: 'Debitor',
          },
          value: 'debtor',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('contracts', ['GET_CONTRACTS']),
    ...mapGetters('objects', ['GET_OBJECTS']),
  },
  mounted() {
    this.FETCH_CONTRACTS({ is_signed: true })
    this.FETCH_OBJECTS({ partial: true })
  },
  methods: {
    ...mapActions('contracts', ['FETCH_CONTRACTS']),
    ...mapActions('objects', ['FETCH_OBJECTS']),
    emitFiltered() {
      this.$emit('refresh', this.query_params)
    },
    clearData() {
      this.query_params = {}
      this.$emit('clearFilter', this.query_params)
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
